import { Grid, Input, NativeSelect, Paper } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MaterialTable from 'material-table';
import React, { useEffect, useMemo, useState } from 'react';
import Pagination from 'react-js-pagination';
import { Link, useHistory } from 'react-router-dom';
import Loading from '../../components/Loading';
import Header from '../../layout/Header';
import Subheader from '../../layout/Subheader';
import api from '../../services/api';
import { findPermission, TOKEN_PAGINATION } from '../../services/auth';
import './pagination.style.css';
import { FilterStatusHeader } from './Provider/components/FilterStatusHeader';
import useStyles from './style';

export function Providers() {
  const classes = useStyles();
  const history = useHistory();
  const [isLoading, setLoading] = useState(true);
  const [providers, setProviders] = useState([]);
  const [classifications, setClassifications] = useState([]);
  const [frequencies, setFrequencies] = useState([]);

  const [razaoSocialInput, setRazaoSocialInput] = useState('');
  const [cnpjCpfInput, setCnpjCpfInput] = useState('');
  const [status, setStatus] = useState('ativo');
  const [antecipacaoInput, setAntecipacaoInput] = useState('');
  const [fornecedorId, setFornecedorId] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itensPerPage, setItensPerPage] = useState(50);
  const [pagination, setPagination] = useState([]);

  const memoizedTable = useMemo(
    () => (
      <MaterialTable
        className={classes.table}
        options={{
          showTitle: false,
          search: false,
          toolbar: false,
          headerStyle: {
            backgroundColor: '#F5F5F5',
            textTransform: 'none',
            fontSize: '15px',
          },
          filtering: true,
          paging: false,
          rowStyle: rowData => ({
            backgroundColor: rowData.corFundo ? rowData.corFundo : 'auto',
            color: rowData.corFonte ? rowData.corFonte : 'auto',
          }),
        }}
        onRowClick={(event, rowData) => {
          if(!!findPermission(711, 'Alterar')) {
            window.location.href = window.location.origin + `/app/fornecedor/${rowData.fornecedorId}/editar`
          }
        }}
        title="Multiple Actions Preview"
        columns={[
          {
            title: 'ID',
            field: 'fornecedorId',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 10px',
              width: '20px',
            },
          },
          {
            title: 'CNPJ/CPF',
            field: 'cnpjCpf',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Razão Social',
            field: 'razaoSocial',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 10px',
              width: '250px',
            },
          },
          {
            title: 'Frequência',
            field: 'frequencia',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 10px',
              width: '100px',
            },
          },
          {
            title: 'Classificação',
            field: 'classificacao',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 10px',
              width: '100px',
            },
          },
          {
            title: 'Status',
            field: 'status',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
              width: '80px',
            },
          },
          {
            title: 'Ações',
            field: 'actions',
            headerStyle: {
              textAlign: 'center',
            },
            cellStyle: {
              fontSize: '13px',
              textAlign: 'center',
              padding: '8px 16px',
            },
            filtering: false,
            sorting: false,
            disableClick: true,
            render: (rowData) => (
              <>
                {!!findPermission(711, 'Consultar') && (
                  <Link
                    className={classes.buttonVisualize}
                    to={`/app/fornecedor/${rowData.fornecedorId}`}
                  >
                    <VisibilityIcon style={{ fontSize: 30, color: '#4AAF05' }} />
                  </Link>
                )}
                {!!findPermission(711, 'Alterar') && (
                  <Link
                    className={classes.buttonEdit}
                    to={`/app/fornecedor/${rowData.fornecedorId}/editar`}
                  >
                    <EditIcon style={{ fontSize: 30, color: '#FB8832' }} />
                  </Link>
                )}
              </>
            ),
          },
        ]}
        data={providers}
      />
    ),
    [providers],
  );

  const fetchProviders = async (
    pageNumber = currentPage,
    currentlyStatus = status,
    currentlyAntec = antecipacaoInput,
    currentlyProviderId = fornecedorId,
  ) => {
    setLoading(true);
    const res = await api.get(
      `Fornecedores/ConsultarGridCadastro?itensPorPagina=${itensPerPage}&paginaInicial=${pageNumber}&razaoSocial=${razaoSocialInput}&cnpjCpf=${cnpjCpfInput}&status=${currentlyStatus}&frequenciaAntecipacaoId=${currentlyAntec}&classificacaoFornecedorId=${currentlyProviderId}`,
    );
    setPagination(res.data.paginacao);
    if(res.data.paginacao.qtdTotalRegistros > 0){
      setProviders(res.data.resposta);
    } else {
      setProviders([]);
    }
    setLoading(false);
  };

  const fetchFilterOptions = async () => {
    const freq = await api.get('FrequenciasAntecipacoes/Consultar?status=Ativo');
    setFrequencies(freq.data.resposta);
    const res = await api.get('ClassificacoesFornecedores/Consultar?status=Ativo');
    setClassifications(res.data.resposta);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchProviders(pageNumber);
  };

  useEffect(() => {
    fetchFilterOptions();
    const userPage = JSON.parse(sessionStorage.getItem(TOKEN_PAGINATION)).paginacao.itensPorPagina;
    setItensPerPage(userPage === 0 ? 50 : userPage);
  }, []);

  useEffect(() => {
    setCurrentPage(1);
    const delayDebounceFn = setTimeout(() => {
      fetchProviders();
    }, 1500);

    return () => clearTimeout(delayDebounceFn);
  }, [cnpjCpfInput, razaoSocialInput, itensPerPage]);

  return (
    <div className={classes.root}>
      <Header />
      <Subheader
        title="Fornecedores"
        back="/app/home"
        create={() => history.push('/app/fornecedor/cadastrar')}
      />
      <div className={classes.content}>
        <div className={classes.rootForm}>
          <header>
            <Grid container className={classes.searchContainer}>
              <Grid item xs={2} className={classes.item}>
                <label className={classes.label}>CPF / CNPJ</label>
                <Paper className={classes.medium} elevation={0}>
                  <Input
                    className={classes.input}
                    value={cnpjCpfInput}
                    placeholder="CPF/CNPJ"
                    onChange={(e) => setCnpjCpfInput(e.target.value)}
                    inputProps={{
                      maxLength: 18,
                    }}
                  />
                </Paper>
              </Grid>
              <Grid item xs={2} className={classes.item}>
                <label className={classes.label}>Razão Social</label>
                <Paper className={classes.medium} elevation={0}>
                  <Input
                    className={classes.input}
                    value={razaoSocialInput}
                    inputProps={{ style: { textTransform: "uppercase" } }}
                    placeholder="Razão Social"
                    onChange={(e) =>{
                      setRazaoSocialInput(
                        e.target.value
                          .normalize('NFD')
                          .replace(/[\u0300-\u036f]/g, '')
                      )
                    }}
                  />
                </Paper>
              </Grid>
              <Grid item xs={2} className={classes.item}>
                <label className={classes.label}>Frequência</label>
                <NativeSelect
                  className={classes.input}
                  value={antecipacaoInput}
                  placeholder="Frequência Antecipação"
                  onChange={(e) => {
                    setAntecipacaoInput(e.target.value);
                    fetchProviders(currentPage, status, e.target.value, fornecedorId);
                  }}
                  style={{ marginBottom: '15px', width: '95%' }}
                >
                  <option value="">Selecione um</option>
                  {frequencies.map((frequency) => (
                    <option
                      key={frequency.frequenciaAntecipacaoId}
                      value={frequency.frequenciaAntecipacaoId}
                    >
                      {frequency.frequencia}
                    </option>
                  ))}
                </NativeSelect>
              </Grid>
              <Grid item xs={2} className={classes.item}>
                <label className={classes.label}>Classificação</label>
                <NativeSelect
                  className={classes.input}
                  value={fornecedorId}
                  placeholder="Classificação fornecedor"
                  onChange={(e) => {
                    setFornecedorId(e.target.value);
                    fetchProviders(currentPage, status, antecipacaoInput, e.target.value);
                  }}
                  style={{ marginBottom: '15px', width: '95%' }}
                >
                  <option value="">Selecione um</option>
                  {classifications.map((classificacao) => (
                    <option
                      key={classificacao.classificacaoFornecedorId}
                      value={classificacao.classificacaoFornecedorId}
                    >
                      {classificacao.classificacao}
                    </option>
                  ))}
                </NativeSelect>
              </Grid>

              <Grid item xs={2} className={classes.item}>
                <label className={classes.label}>Status</label>
                <Paper className={classes.medium} elevation={0}>
                  <NativeSelect
                    className={classes.input}
                    onChange={(event) => {
                      setStatus(event.target.value);
                      setCurrentPage(1);
                      fetchProviders(1, event.target.value);
                    }}
                    value={status}
                  >
                    <option value="">Todos</option>
                    <option value="ativo">Ativo</option>
                    <option value="inativo">Inativo</option>
                    <option value="pendente">Pendente</option>
                  </NativeSelect>
                </Paper>
              </Grid>

              <Grid
                item
                xs={2}
                className={classes.item}
                style={{ margin: '0 0 0 auto', display: 'flex', justifyContent: 'flex-end' }}
              >
                <button className={classes.buttonFilter} onClick={() => fetchProviders()}>
                  Aplicar Filtro
                </button>
              </Grid>
            </Grid>
          </header>
          {isLoading ? (
            <Loading />
          ) : (
            <>
              {memoizedTable}
              <div className="footer-table">
                <Pagination
                  activePage={currentPage}
                  itemsCountPerPage={itensPerPage}
                  totalItemsCount={pagination.qtdTotalRegistros}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
                <div className="select-page">
                  <label>Qtd. por página</label>
                  <NativeSelect
                    onChange={(e) => setItensPerPage(Number(e.currentTarget.value))}
                    value={itensPerPage}
                  >
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                  </NativeSelect>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
